import React, { useEffect, useRef, useState } from "react";
import { request } from "../../../functions/request";
import {
  Button,
  Checkbox,
  DatePicker,
  Descriptions,
  Form,
  Input,
  message,
  Select,
  Tooltip,
} from "antd";
import { updateData, verificarVariacaoValor } from "../../../functions/functionsUtility";
import { FaSave } from "react-icons/fa";
import { sojaStatesOptions } from "../../../constants/constants";
import dayjs from "dayjs";

const sojaOptions = [
  { value: "soj_comp_min", label: "Preço Min. ao Compr:", span: 2 },
  { value: "min_cif", label: "CIF:", span: 1, type: "checkbox" },
  { value: "soj_comp", label: "Preço Máx. ao Comp:", cif: "max_cif", span: 2 },
  { value: "max_cif", label: "CIF:", span: 1, type: "checkbox" },
];

export default function IntergraosSojaPorEstado() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [uf, setUf] = useState(null);
  const [date, setDate] = useState(dayjs().format("DD/MM/YYYY"));
  // Snapshot imutável do valor carregado da API, pra comparar contra o que
  // o usuário digita (cotacoesData já vai sendo sobrescrito a cada tecla).
  const baselineRef = useRef({});
  // Campos com valor fora do padrão (10% de variação) — além do toast,
  // marca o input com borda de alerta + tooltip explicando o motivo,
  // já que o toast some sozinho depois de alguns segundos.
  const [camposComAlerta, setCamposComAlerta] = useState({});

  const onChange = (date, dateString) => {
    setDate(dateString);
  };

  async function getData(values) {
    console.log(values);
    setIsLoading(true);
    const currentPathWithQuery = `/soja_cotacao/getSojaCotacao?uf=${
      values.uf
    }&data=${encodeURIComponent(values.date)}`;
    const response = await request(currentPathWithQuery, {
      method: "GET",
    }).catch((reason) => {
      console.log(reason);
      setCotacoesData("");
    });
    console.log(response);
    // Praça sem cotação nesta data (ex.: mercado novo, como PA): formulário
    // em branco para a UF e o dia escolhidos — a API cria a linha ao salvar.
    const linha = Array.isArray(response) ? response[0] : undefined;
    const data = {
      ...(linha || {
        soj_uf: values.uf,
        soj_data: dayjs(values.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
        soj_comp_min: "",
        soj_comp: "",
        semCotacao: true,
      }),
      endpoint: "updateSojaCotacao",
      path: "soja_cotacao",
    };
    Object.keys(data).forEach((el, index) => {
      if (typeof data[el] === "number") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].replace(".", ",");
      }
    });
    setCotacoesData(data);
    baselineRef.current = data;
    setCamposComAlerta({});
    setIsLoading(false);
  }

  useEffect(() => {
    if (uf && date) getData({ uf, date });
  }, [uf, date]);

  console.log(cotacoesData);

  return (
    <Form>
      <Descriptions
        title={"Intergrãos - Soja - Alterando Cotação Por Estado"}
        bordered
        extra={
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            icon={<FaSave />}
            disabled={isLoading}
            onClick={() => {
              console.log(cotacoesData);
              if (cotacoesData?.semCotacao && sojaOptions.some((o) => o.type !== "checkbox" && !cotacoesData[o.value])) {
                message.warning("Preencha os preços mínimo e máximo para criar a primeira cotação desta praça.");
                return;
              }
              updateData(cotacoesData);
            }}
          >
            Atualizar
          </Button>
        }
        style={{ padding: 10 }}
      >
        <Descriptions.Item
          label={"Estado"}
          span={2}
          children={
            <Select
              style={{ width: "100%", marginTop: "10px" }}
              onChange={(value) => {
                setCotacoesData({ ...cotacoesData, soj_uf: value });
                setUf(value);
              }}
              placeholder="Selecione o estado"
            >
              {sojaStatesOptions.map((el, index) => {
                return (
                  <Select.Option key={index} value={el.value}>
                    {el.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
        />
        <Descriptions.Item
          label={"Data"}
          span={1}
          children={
            <DatePicker
              defaultValue={dayjs()}
              format={"DD/MM/YYYY"}
              onChange={onChange}
            />
          }
        />
        <Descriptions.Item
          label={"Última Alteração"}
          span={3}
          children={
            cotacoesData?.semCotacao
              ? "Sem cotação nesta data — será criada ao salvar"
              : dayjs(cotacoesData?.soj_data, "YYYY-MM-DDTHH:mm:ss.zzz").format("DD/MM/YYYY [às] HH:mm")
          }
        />
        {!isLoading &&
          sojaOptions.map((element) => (
            <Descriptions.Item
              label={element.label}
              span={element.span}
              children={
                element?.type === "checkbox" ? (
                  <Checkbox
                    checked={cotacoesData[element.value]}
                    onChange={(event) => {
                      const inputValue = event.target.checked;
                      const formattedValue = inputValue;
                      const newData = {
                        ...cotacoesData,
                        [element.value]: formattedValue,
                      };
                      setCotacoesData(newData);
                    }}
                  />
                ) : (
                  <Tooltip
                    title={camposComAlerta[element.value]?.mensagem}
                    open={!!camposComAlerta[element.value]}
                    color="orange"
                  >
                    <Input
                      datatype=""
                      status={camposComAlerta[element.value] ? "warning" : ""}
                      value={cotacoesData[element.value]}
                      onChange={(event) => {
                        const inputValue = event.target.value;
                        const formattedValue = inputValue.trim();
                        const newData = {
                          ...cotacoesData,
                          [element.value]: formattedValue,
                        };
                        setCotacoesData(newData);
                      }}
                      onBlur={() => {
                        const alerta = verificarVariacaoValor(
                          cotacoesData[element.value],
                          baselineRef.current[element.value],
                          element.label
                        );
                        setCamposComAlerta((prev) => ({
                          ...prev,
                          [element.value]: alerta,
                        }));
                      }}
                    />
                  </Tooltip>
                )
              }
            />
          ))}
      </Descriptions>
    </Form>
  );
}
